<template>
    <div>
        <self-map
            @click="clickMap"
            style="z-index: 0"
            :style="`height: ${height}`"
            :zoom="zoom" :center="center"
            :options="lock ? lockOptions : options">
            <self-tile-layer :url="url" :attribution="attribution"></self-tile-layer>
            <span v-for="(point, index) in points" :key="index + 'm'">
                <self-marker
                    @click="point.click ? point.click() : undefined"
                    :lat-lng="getGeoPosition(point.lat, point.lng)">
                </self-marker>
                <self-circle :lat-lng="getGeoPosition(point.lat, point.lng)" v-if="point.radius"  :radius="point.radius"></self-circle>
            </span>
            <slot></slot>
        </self-map>
    </div>
</template>

<script>
// https://vue2-leaflet.netlify.app

import L, { Icon } from 'leaflet'
import { LMap, LTileLayer, LMarker, LCircle } from 'vue2-leaflet'

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png')
})

export default {
    props: {
        lock: {
            default: false
        },
        zoom: {
            default: 6.5
        },
        height: {
            default: '200px'
        },
        points: {
            default: () => []
        }
    },
    data() {
        return {
            center: L.latLng(23.61565, 120.973882),
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            options: {
                zoomControl: false,
                attributionControl: false
            },
            lockOptions: {
                minZoom: this.zoom,
                maxZoom: this.zoom,
                dragging: false,
                zoomControl: false,
                attributionControl: false
            }
        }
    },
    components: {
        'self-map': LMap,
        'self-marker': LMarker,
        'self-circle': LCircle,
        'self-tile-layer': LTileLayer
    },
    methods: {
        clickMap(data) {
            this.$emit('click', data)
        },
        getGeoPosition(lat, lng) {
            return L.latLng(lat, lng)
        },
        setCenter(lat, lng) {
            this.center = L.latLng(lat, lng)
        }
    }
}
</script>